<template>
  <form
    class="callback-form"
    :class="{ CKiForm: CONSTANTS.cKeeper === 'iform' }"
    ref="form"
    @submit.prevent="submitThis"
    onSubmit="ym(89369543,'reachGoal','send_form');"
  >
    <div class="controls">
      <input
        name="”tel”"
        type="tel"
        :title="'Введите номер телефона'"
        :class="textColor"
        placeholder="Ваш телефон"
        v-model="phone"
        ref="phone"
        v-mask
        :pattern="'.*[0-9]{1}.*[0-9]{3}.*[0-9]{3}.*[0-9]{4}'"
        required
      />
      <button
        class="button"
        :class="[
          { disabled: !acceptance },
          { CKFormTrigger: CONSTANTS.cKeeper === 'iform' },
          button_class,
        ]"
        :disabled="!acceptance"
        ref="submitter"
      >
        <slot></slot>
        {{ $slots.default ? "" : "ОТПРАВИТЬ ЗАЯВКУ" }}
      </button>
    </div>
    <div class="agreement" v-if="CONSTANTS.need_agreement">
      <checkbox v-model="acceptance" />
      <div class="agreement-text">
        <span class="agreement-caller">
          Согласие на дальнейшую коммуникацию*
        </span>
      </div>
    </div>
  </form>
</template>

<script>
import Checkbox from "../checkbox";
import Mask from "@/common/mask";
import Mixin from "@/common/mixin";

export default {
  name: "",
  components: { Checkbox },
  directives: { Mask },
  mixins: [Mixin],
  props: ["data", "btn_theme", "textColor"],
  data() {
    return {
      acceptance: true,
      phone: "",
    };
  },
  computed: {
    button_class() {
      return this.btn_theme ? this.btn_theme : "button_theme_primary";
    },
  },
  methods: {
    submitThis() {
      if (
        this.$refs.phone.validity.valueMissing ||
        !this.$refs.phone.validity.valid
      ) {
        this.$refs.phone.setCustomValidity("Введите номер телефона");
      }
      if (
        !this.$refs.phone.validity.valueMissing &&
        !this.$refs.phone.validity.patternMismatch
      ) {
        this.$refs.phone.setCustomValidity("");
      }
      if (this.acceptance && this.$el.reportValidity()) {
        this.$emit("callBack", {
          phone: this.phone,
          data: this.data,
        });
        if (
          this.CONSTANTS.cKeeper === "iform" &&
          typeof ckForms !== "undefined"
        ) {
          ckForms.send(this.$refs.form);
        }
      }
    },
    getAgreement() {
      this.$emit("getAgreement");
    },
  },
};
</script>

<style scoped lang="scss" src="./style.scss"></style>
